import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.data('dialog', (element: string) => ({
  dialogElement: document.querySelector(`#${element}`) as HTMLDialogElement,
  closeOnBackdropClick(event: MouseEvent) {
    if (event.target === this.$el) {
      (this.$el as HTMLDialogElement).close();
    }
  },
  openDialog: {
    ['@click']() {
      console.log(this.dialogElement);
      this.dialogElement.showModal();
    },
  },
  closeDialog: {
    ['@click']() {
      console.log(this.dialogElement);
      this.dialogElement.close();
    },
  },
}));
